angular.module('cvsApp').factory('getDigitalSpecialtySSOTokenModel',[function() {	
	'use strict';
	var getDigitalSpecialtySSOTokenService = function(){
		var self = this;	
		
		this.setResponse = function(data){
            self = data ;		
		};

		this.getResponse =function (){
            var viewdata ={};
            
	        if(getHeader().statusCode === "0000" || getHeader().statusCode === "DBPL0000"){
	            viewdata = getDetails();           
	        }else if(getHeader().statusCode === "6621" || getHeader().statusCode === "6622"){
	           //send message to parent
				//cvsUtility.genralPostMessage("EMPTY_FRAME",'{isEmpty:true}');
	            viewdata.isViewError = true;
	            viewdata.apiMsg = getHeader();
	        }else{          
	            viewdata.showError = getHeader();
	        }	        
	        return viewdata;			
        };
        
		var getHeader =function (){
            if (self.hasOwnProperty('digitalSpecialtySSOTokenResponse')) {
                return self.digitalSpecialtySSOTokenResponse.header;
            }
		};

		var getDetails =function (){
			if(self.hasOwnProperty('digitalSpecialtySSOTokenResponse')){
				return self.digitalSpecialtySSOTokenResponse;
			}
		};
	
	};
	
	return new getDigitalSpecialtySSOTokenService();
}]);
